import { Provider } from 'react-redux';
import { store } from 'store';
import { AppSettingsProviderWrapper } from 'AppSettingsProviderWrapper';

import React from 'react';

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider store={store}>
      <AppSettingsProviderWrapper>{children}</AppSettingsProviderWrapper>
    </Provider>
  );
};
